import { Box, Container, Grid } from "@mui/material";
import React from "react";
import Img1 from "./../assets/images/sharatoneau/sharaton_first.jpg";
import Img2 from "./../assets/images/sharatoneau/sharaton_second.jpg";
import Img3 from "./../assets/images/sharatoneau/sharaton_third.jpg";
import Img4 from "./../assets/images/sharatoneau/sharaton_four.jpg";
import Img5 from "./../assets/images/sharatoneau/sharaton_five.jpg";
import Img6 from "./../assets/images/sharatoneau/sharaton_six.jpg";
import Img7 from "./../assets/images/sharatoneau/sharaton_seven.jpg";
import Img8 from "./../assets/images/sharatoneau/sharaton_eight.jpg";
import Contentimages from "../components/Contentimages";
import PostRealetedDates from "../components/PostRealetdDates";
import ProtfolioNavigation from "../components/ProtfolioNavigation";
import { Link } from "react-router-dom";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

const Sheratoneau = () => {
  const imageArray = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8];

  const relatedDates = [
    {
      title: "MEG Energy",
      url: "/portfolio_page/meg-energy/",
      date: "May 18, 2017",
    },
    {
      title: "Alberta Utilities Commission",
      url: "/portfolio_page/alberta-utilities-commission/",
      date: "April 20, 2018",
    },
    {
      title: "Burnet, Duckworth & Palmer LLP",
      url: "/portfolio_page/burnet-duckworth-palmer/",
      date: "September 24, 2012",
    },
  ];

  useDocumentMetaData({
    title: "Sheraton Eau Claire Lobby Renovation - MidWest Group",
    description:
      "MidWest Group updated the lobby ceilings at Sheraton Suites Calgary Eau Claire, including drywall ceilings, light coves, recessed MDF access panels, and Armstrong Soundscapes Shapes panels.",
    keywords:
      "Sheraton Eau Claire, Calgary lobby renovation, MidWest Group projects, drywall ceilings, Soundscapes Shapes, Armstrong ceilings, B+H Architects, Ryan Murphy Construction",
    canonical:
      "https://www.midwest-group.com/portfolio_page/sheraton-eau-claire/",
    author: "MidWest Group",
    ogTitle: "Sheraton Eau Claire Lobby Renovation",
    ogDescription:
      "MidWest Group delivered a striking contemporary ceiling design for Sheraton Suites Calgary Eau Claire, including drywall, light coves, and acoustic panels by Armstrong.",
    ogImage: "https://www.midwest-group.com/static/media/sharaton_first.4ae9e6c4baf95a662664.jpg",
    ogUrl: "https://www.midwest-group.com/portfolio_page/sheraton-eau-claire/",
    twitterTitle: "Sheraton Eau Claire Lobby Renovation",
    twitterDescription:
      "Explore MidWest Group's work updating the lobby ceilings of Sheraton Suites Calgary Eau Claire, featuring drywall, light coves, and Armstrong Soundscapes Shapes panels.",
    twitterImage:
      "https://www.midwest-group.com/static/media/sharaton_first.4ae9e6c4baf95a662664.jpg",
  });

  return (
    <>
      <div className="parent-div">
        <Container
          fixed
          className="parent-container"
          style={{ paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Box>
            <Contentimages
              tab={"Calgary, Alberta"}
              heading={"Sheraton Eau Claire"}
              imageArray={imageArray}
            >
              With a mission to update the lobby ceilings at Sheraton Suites
              Calgary Eau Claire, we were pleased to work under contract to{" "}
              <Link
                to={"https://ryanmurphyconstruction.com/"}
                target="_blank"
                className="navigation-link"
              >
                Ryan Murphy Construction.
              </Link>{" "}
              Designed by{" "}
              <Link
                to={"https://bharchitects.com/en/"}
                target="_blank"
                className="navigation-link"
              >
                B+H Architects,
              </Link>{" "}
              the new ceilings create a striking statement in the spacious
              lobby. Besides drywall ceilings and light coves, our scope
              encompassed the supply and install of recessed MDF access panels
              and Soundscapes Shapes panels. The white{" "}
              <Link
                to={
                  "https://www.armstrongceilings.com/commercial/en/commercial-ceilings-walls/soundscapes-shapes-ceiling-clouds.html"
                }
                target="_blank"
                className="navigation-link"
              >
                Soundscapes Shapes panels by Armstrong
              </Link>{" "}
              serve a double-duty: a creative design element as well as
              much-needed acoustic control in the large hotel lobby. The result
              is a bright, expansive, contemporary ceiling that will serve
              Sheraton’s clientele for many years to come.
            </Contentimages>
            <Grid container paddingBottom={10}></Grid>
            <PostRealetedDates relatedDates={relatedDates} />
            <ProtfolioNavigation
              backUrl="/portfolio_page/harry-hays-parks-canada-2/"
              nextUrl="/portfolio_page/alberta-utilities-commission/"
            />
          </Box>
        </Container>
      </div>
    </>
  );
};

export default Sheratoneau;
